export const REQUEST_FETCH_CONTACTS_FOR_EVENT =
  "REQUEST_FETCH_CONTACTS_FOR_EVENT";
export const FETCH_CONTACTS_FOR_EVENT_SUCCESS =
  "FETCH_CONTACTS_FOR_EVENT_SUCCESS";
export const FETCH_CONTACTS_FOR_EVENT_FAILURE =
  "FETCH_CONTACTS_FOR_EVENT_FAILURE";

export const CLEAR_FETCH_CONTACTS_FOR_EVENT = "CLEAR_FETCH_CONTACTS_FOR_EVENT";
